const cloneDeep = require("lodash.clonedeep");

export default {
  install(Vue, { store, ElementUI }) {
    let elementUI = ElementUI;
    let cachePet = {};
    let cacheUser = {};
    let tag = "cachePlugin";
    let waitingQueue = {};
    Vue.prototype.$cache = {
      init: async function () {
        this.purgeAll();
        Vue.prototype.$change.addPetListener(petUpdate);
        Vue.prototype.$change.addUserListener(userUpdate);
      },
      getPet: async function (id) {
        return getDoc(cachePet, id);
      },
      getPets: async function (ids) {
        return getDocs(cachePet, ids);
      },
      getUser: async function (id) {
        return getDoc(cacheUser, id);
      },
      getUsers: async function (ids) {
        return getDocs(cacheUser, ids);
      },
      warmUpPetUser(ids) {
        let warmPetID = [];
        let warmUserID = [];
        ids.forEach((id) => {
          if (cachePet[id]) {
            if (cachePet[id].userID && !cacheUser[cachePet[id].userID]) {
              warmUserID.push(cachePet[id].userID);
              if (!waitingQueue.hasOwnProperty(cachePet[id].userID)) {
                waitingQueue[cachePet[id].userID] = [];
              }
            }
          } else if (id) {
            warmPetID.push(id);
            if (!waitingQueue.hasOwnProperty(id)) {
              waitingQueue[id] = [];
            }
          }
        });

        return new Promise((resolve) => {
          let promise;
          if (warmPetID.length) {
            // console.log(
            //   `[${tag}] warmPetID ${warmPetID} query(${warmPetID.length})`
            // );
            promise = window.NxVetV2.batchReadKeys(warmPetID);
          } else {
            promise = Promise.resolve({ result: [] });
          }
          promise
            .then((res) => {
              let pets = res.result;
              pets.forEach((pet) => {
                cachePet[pet._id] = pet;
                if (!cacheUser[pet.userID]) {
                  warmUserID.push(pet.userID);
                  if (!waitingQueue.hasOwnProperty(pet.userID)) {
                    waitingQueue[pet.userID] = [];
                  }
                }
              });

              if (warmUserID.length) {
                // console.log(
                //   `[${tag}] warmUserID ${warmUserID} query(${warmUserID.length})`
                // );
                return window.NxVetV2.batchReadKeys(warmUserID);
              } else {
                return Promise.resolve({ result: [] });
              }
            })
            .then((res) => {
              let users = res.result;
              users.forEach((user) => {
                cacheUser[user._id] = user;
              });
            })
            .then(() => {
              warmPetID.forEach((petID) => {
                while (waitingQueue[petID] && waitingQueue[petID].length) {
                  waitingQueue[petID].shift()(cloneDeep(cachePet[petID]));
                }
                delete waitingQueue[petID];
              });
              warmUserID.forEach((userID) => {
                while (waitingQueue[userID] && waitingQueue[userID].length) {
                  waitingQueue[userID].shift()(cloneDeep(cacheUser[userID]));
                }
                delete waitingQueue[userID];
              });
              resolve();
            })
            .catch((error) => {
              console.error(error);
              let warmID = [];
              warmID = warmID.concat(warmUserID);
              warmID = warmID.concat(warmPetID);
              warmID.forEach((id) => {
                while (waitingQueue[id] && waitingQueue[id].length) {
                  waitingQueue[id].shift()({});
                }
                delete waitingQueue[id];
              });
              // console.log(`[${tag}] ${warmID} resolve error`);
              elementUI.Message({
                showClose: true,
                type: "error",
                message: "讀取飼主寵物資料失敗",
              });
              resolve();
            });
        });
      },
      purgeAll: async function () {
        Vue.prototype.$change.removePetListener(petUpdate);
        Vue.prototype.$change.removeUserListener(userUpdate);
        cachePet = {};
        cacheUser = {};
      },
    };
    let getDoc = (cache, id) => {
      if (!id) {
        return Promise.resolve({});
      }
      if (cache.hasOwnProperty(id)) {
        // console.log(`[${tag}] ${id} hit`);
        return Promise.resolve(cloneDeep(cache[id]));
      } else {
        return new Promise((resolve) => {
          if (waitingQueue.hasOwnProperty(id)) {
            // console.log(`[${tag}] ${id} push to waiting queue`);
            waitingQueue[id].push(resolve);
          } else {
            // console.log(`[${tag}] ${id} query`);
            waitingQueue[id] = [];

            let promise;
            //  window.NxVet.get(id)
            if (id.startsWith("/pet")) {
              promise = window.NxVetV2.getPet(id);
            } else {
              promise = window.NxVetV2.getUser(id);
            }

            promise
              .then((res) => {
                let doc = res.result;
                cache[id] = doc;
                while (waitingQueue[id] && waitingQueue[id].length) {
                  waitingQueue[id].shift()(cloneDeep(doc));
                }
                delete waitingQueue[id];
                // console.log(`[${tag}] ${id} resolve`);
                resolve(cloneDeep(doc));
              })
              .catch((error) => {
                console.error(error);
                while (waitingQueue[id] && waitingQueue[id].length) {
                  waitingQueue[id].shift()({});
                }
                delete waitingQueue[id];
                elementUI.Message({
                  showClose: true,
                  type: "error",
                  message: "讀取飼主寵物資料失敗",
                });
                // console.log(`[${tag}] ${id} resolve error`);
                resolve({});
              });
          }
        });
      }
    };

    let getDocs = (cache, ids) => {
      let result = {};
      let batchID = [];
      ids.forEach((id) => {
        if (cache[id]) {
          result[id] = cloneDeep(cache[id]);
        } else {
          batchID.push(id);
          if (!waitingQueue.hasOwnProperty(id)) {
            waitingQueue[id] = [];
          }
        }
      });

      if (!batchID.length) {
        // console.log(`[${tag}] ${ids} hit`);
        return Promise.resolve(result);
      } else {
        return new Promise((resolve) => {
          // console.log(`[${tag}] ${batchID} query(${batchID.length})`);
          window.NxVetV2.batchReadKeys(batchID)
            .then((res) => {
              let docs = res.result;
              docs.forEach((doc) => {
                cache[doc._id] = doc;
                result[doc._id] = cloneDeep(doc);
                while (waitingQueue[doc._id] && waitingQueue[doc._id].length) {
                  waitingQueue[doc._id].shift()(cloneDeep(doc));
                }
                delete waitingQueue[doc._id];
                // console.log(`[${tag}] ${doc._id} resolve`);
              });

              resolve(result);
            })
            .catch((error) => {
              console.error(error);
              batchID.forEach((id) => {
                result[id] = {};
                while (waitingQueue[id] && waitingQueue[id].length) {
                  waitingQueue[id].shift()({});
                }
                delete waitingQueue[id];
                // console.log(`[${tag}] ${id} resolve error`);
              });
              elementUI.Message({
                showClose: true,
                type: "error",
                message: "讀取飼主寵物資料失敗",
              });
              resolve(result);
            });
        });
      }
    };

    let petUpdate = (id, pet) => {
      // console.log(`[${tag}] petUpdate[${id}]:` + JSON.stringify(pet));
      cachePet[id] = pet;
    };

    let userUpdate = (id, user) => {
      // console.log(`[${tag}] userUpdate[${id}]:` + JSON.stringify(user));
      cacheUser[id] = user;
    };
  },
};
